<template>
  <div class="measurement-card" v-on:click="show(measurement)">
    <span class="measurement-result">{{ formatWaistMeasurement(measurement.measurement) }} cm</span>
    <span class="measurement-date float-right">{{ formatDateTime(measurement) }}</span>
    <span v-if="measurement.comment" class="measurement-comment">{{ measurement.comment }}</span>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "WaistCard",
  props: {
    measurement: Object
  },
  data: function() {
    return { store: store };
  },
  methods: {
    initData: function() {},
    show: function(measurement) {
      this.$router.push({
        name: "waist.show",
        params: { id: measurement.id }
      });
    },    
    formatWaistMeasurement: function(rawWaistMeasurement) {
      var number = parseInt(rawWaistMeasurement) / 10;
      return number
        .toFixed(1)
        .toString()
        .replace(".", ",");
    },

    getScaleFullName: function(scaleId) {
      if (scaleId == null) {
        return "-";
      }

      let scale = this.store.getScale(scaleId);

      if (scale == undefined) {
        return "-";
      }

      return scale.manufacturer + " " + scale.model;
    },
    formatRawDate: function(rawDate) {
      return this.moment(rawDate).format("D.M.YYYY");
    },
    formatRawDateTime: function(rawDate, rawTime) {
      return this.moment(rawDate + " " + rawTime).format("D.M.YYYY HH:mm");
    },
    formatDateTime: function(measurement) {
      if (measurement.time == null) {
        return this.formatRawDate(measurement.date);
      }

      return this.formatRawDateTime(measurement.date, measurement.time);
    },
    hasScale(measurement) {
      return measurement.scale_id != null && measurement.scale_id > 0;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.measurement-card {
  cursor: pointer;
  border-radius: 0.25rem;
  /* width: 18rem; */
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.8rem;
  margin-bottom: 1rem;
  vertical-align: top;
}
.measurement-date {
  font-size: 70%;
  color: gray;
  padding: 0;
  margin: 0; 
}

.measurement-result {
  font-weight: bold;
  font-size: 120%;
  color: #222;
}

.measurement-comment {
  font-size: 80%;
  color: rgb(116, 116, 116);
  display: block;
  margin: 0;
  padding: 0;
}
</style>
